import { Component, computed, input, output, Signal } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { isNotNil, Nillable } from '@web/utils';
import { TableFilterConfig } from '../../models/table-filter-config';
import { TableFilterChangeEvent } from '../../events/table-filter-change.event';
import { TableColumnType } from '../../enums/table-column-type';
import { TableFilterComponent } from '../table-filter/table-filter.component';
import { CollectionFilterKey } from '@web/common';
import { TableHeaderCurrentPageRowSelectionCheckboxComponent } from '../table-header-current-page-row-selection-checkbox/table-header-current-page-row-selection-checkbox.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'th[app-table-filter-cell]',
  imports: [
    TableFilterComponent,
    TableHeaderCurrentPageRowSelectionCheckboxComponent,
  ],
  templateUrl: './table-filter-cell.component.html',
  styleUrls: ['./table-filter-cell.component.scss'],
})
export class TableFilterCellComponent<Item, Filter> {
  public readonly column = input.required<TableColumn<Item, Filter>>();
  public readonly filter = input<Nillable<TableFilterConfig<Filter>>>();
  public readonly filterChanges = output<TableFilterChangeEvent<Filter>>();

  protected readonly TableColumnType = TableColumnType;

  protected readonly shouldShowFilter = this.shouldShowFilterSignal();
  protected readonly columnType = this.columnTypeSignal();
  protected readonly filterKey = this.filterKeySignal();

  protected handleFilterChanges(event: TableFilterChangeEvent<Filter>): void {
    this.filterChanges.emit(event);
  }

  protected shouldShowFilterSignal(): Signal<boolean> {
    return computed(() => this.column().filterable && isNotNil(this.filter()));
  }

  private columnTypeSignal(): Signal<TableColumnType> {
    return computed(() => this.column().type);
  }

  private filterKeySignal(): Signal<Nillable<CollectionFilterKey<Filter>>> {
    return computed(() => this.column().filterKey);
  }
}
